import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Card } from 'src/app/core/models/card/card.model';
import { PaginationData } from 'src/app/core/models/pagination-data.model';

@Component({
  selector: 'app-staff-cards-in-room-list',
  templateUrl: './staff-cards-in-room-list.component.html',
  styleUrl: './staff-cards-in-room-list.component.scss',
  providers: [DatePipe],
})
export class StaffCardsInRoomListComponent implements OnInit, OnChanges {
  @Input({ required: true }) allStaffCards: Card[] = [];

  staffCardSearchValue = '';
  paginationData: PaginationData = new PaginationData();
  pageSize = 10;
  displayedStaffCards: Card[] = []; // filtered and paginated

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {}

  ngOnChanges() {
    // triger display update on new data from allStaffCards
    this.paginationData = this.newPaginationData(1, this.allStaffCards.length, this.pageSize);
    this.displayedStaffCards = this.paginateData(this.allStaffCards, this.pageSize, 1);
  }

  onAfterSearchStaffCardsChange(value) {
    this.staffCardSearchValue = value;
    const currentPage = 1;
    const filteredStaffCards = this.searchCardsFilter(
      this.allStaffCards,
      this.staffCardSearchValue
    );
    this.paginationData = this.newPaginationData(
      currentPage,
      filteredStaffCards.length,
      this.pageSize
    );
    this.displayedStaffCards = this.paginateData(
      filteredStaffCards,
      this.pageSize,
      currentPage
    );
  }

  clickTargetPage(currentPage: number) {
    const filteredStaffCards = this.searchCardsFilter(
      this.allStaffCards,
      this.staffCardSearchValue
    );
    this.paginationData = this.newPaginationData(
      currentPage,
      filteredStaffCards.length,
      this.pageSize
    );
    this.displayedStaffCards = this.paginateData(
      filteredStaffCards,
      this.pageSize,
      currentPage
    );
  }

  newPaginationData(currentPage: number, totalCount: number, pageSize: number) {
    const totalPages = Math.ceil(totalCount / pageSize);
    const paginationData = {
      TotalCount: totalCount,
      PageSize: pageSize,
      CurrentPage: currentPage,
      TotalPages: totalPages,
      HasNext: currentPage < totalPages,
      HasPrevious: currentPage > 1,
    };
    return paginationData;
  }

  paginateData<T>(items: T[], pageSize: number, currentPage: number): T[] {
    if (!items || items.length === 0) {
      return [];
    }
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return items.slice(startIndex, endIndex);
  }

  searchCardsFilter(cards: Card[], searchText: string): Card[] {
    if (!cards) {
      return [];
    }
    if (!searchText) {
      return cards;
    }
    return cards.filter((card: any) => {
      return (
        card.user?.fullName
          .toLocaleLowerCase()
          .includes(searchText.toLocaleLowerCase()) ||
        this.datePipe
          .transform(new Date(card.validFrom), 'dd.MM.yyyy. - HH:mm')
          .includes(searchText) ||
        this.datePipe
          .transform(new Date(card.validTo), 'dd.MM.yyyy. - HH:mm')
          .includes(searchText)
      );
    });
  }
}
